if (window.dataLayer?.[0]?.triggerRsLogout) {
  fetch(`${RS_ORIGIN}/reviews-api/sessions/logout`, { method: 'DELETE', credentials: 'include' }).catch(() => {});
}
